<template>
  <a-row :gutter="24" type="flex">

    <!-- Projects Table Column -->
    <a-col :span="24" class="mb-24">

      <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0}">
        <template #title>
          <a-row type="flex" align="middle">
            <a-col :span="24" :md="12" class="top-left-header">
              <h5 class="font-semibold m-0">
                Game List
                <a-spin v-if="confirmLoading"/>
              </h5>
            </a-col>
            <a-col :span="24" :md="12" class="top-right-header">
              <a-button><router-link to="/new-game-store">Add New Game</router-link></a-button>
              <a-radio-group v-model="projectHeaderBtns" size="small" @change="onStatusChange">
                <a-radio-button value="all">All</a-radio-button>
                <a-radio-button value="daily">Daily</a-radio-button>
                <a-radio-button value="weekly">Weekly</a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </template>
        <a-table :columns="columnData"
                 :data-source="gameList"
                 :pagination="false">

          <template slot="name" slot-scope="text">
            <a>{{ text }}</a>
          </template>

          <template slot="updateBtn" slot-scope="row">
            <div>
              <a-button type="link" :data-id="row.key">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                     @click="updateGame(row.details.id)">
                  <path class="fill-gray-7"
                        d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"/>
                  <path class="fill-gray-7"
                        d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"/>
                </svg>
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"
                     @click="showDetailsModal(row.details)">
                  <path
                      d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z"/>
                </svg>
              </a-button>
            </div>
          </template>
        </a-table>

        <div class="pagination">
          <a-pagination
              v-model:current="currentPage"
              :total="pagination.total"
              :page-size="20"
              :hideOnSinglePage="true"
              @change="onPageChange"
          />
        </div>
      </a-card>

    </a-col>
    <!-- / Projects Table Column -->

    <!--    Add New Game-->
    <a-modal
        v-model:modalOpen="modalOpen"
        title="Game Details"
        @ok="closeDetailsModal"
    >

    </a-modal>
  </a-row>
</template>

<script>
import {sendRequest} from '@/http/axios.method';
import router from "@/router";

const COLUMN_DATA = [
  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: {customRender: 'id'},
    width: 90,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    width: 200,
  },
  {
    title: 'Tournament Type',
    dataIndex: 'tournament_type',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Latest',
    dataIndex: 'is_latest',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Popular',
    dataIndex: 'is_popular',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Tournament',
    dataIndex: 'is_tournament',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Published',
    dataIndex: 'is_published',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Weight',
    dataIndex: 'weight',
    class: 'font-semibold text-muted',
  },

  {
    title: 'Action',
    scopedSlots: {customRender: 'updateBtn'},
    width: 200,
  },
];

export default {
  name: "ChampionBattleGame",
  data() {
    return {
      config: {
        'Authorization': 'Bearer ' + this.$store.state.authUser.token
      },
      columnData: COLUMN_DATA,
      games: [],
      projectHeaderBtns: 'all',
      currentPage: 1,
      pagination: {},
      confirmLoading: false,

      //Add New Game
      modalOpen: false,

      //Update Category
      updateCategoryModal: false,
      updateCategoryId: '',
      updateCategoryName: '',
      updateCategoryStatus: false,

      //Game Details Modal
      detailsModal: false,
      gameDetails: [],
    }
  },
  created() {
    this.getGameList();
  },
  methods: {
    onStatusChange() {
      this.getGameList()
    },
    onPageChange() {
      this.getGameList()
    },
    getGameList() {
      this.confirmLoading = true;
      let data = {
        page: this.currentPage,
        tournament_type: this.projectHeaderBtns
      }
      sendRequest('get', 'admin/champions-battle-game-list', data, this.config)
          .then(response => {
            this.confirmLoading = false;
            if (response.success) {
              let data = response.data.game_list
              this.games = data.map(function (content, label) {
                return {
                  key: label + 1,
                  id: content.id,
                  name: content.name,
                  tournament_type: content.tournament_type,
                  is_latest: content.is_latest ? 'Yes' : 'No',
                  is_popular: content.is_popular ? 'Yes' : 'No',
                  is_tournament: content.is_tournament ? 'Yes' : 'No',
                  is_published: content.is_published ? 'Yes' : 'No',
                  weight: content.weight,
                  details: content
                };
              });
              this.pagination = response.data.meta.pagination
              this.currentPage = this.pagination.current_page
            } else {
              if (response.status_code === 401) {
                this.$store.dispatch('logout');
                this.$router.push('/login');
              }
            }
          })
          .catch(() => {
            this.confirmLoading = false;
          })
          .finally(() => {
            this.confirmLoading = false;
          })
    },


    showDetailsModal(content) {
      this.modalOpen = true;
      this.gameDetails = content;
    },
    closeDetailsModal() {
      this.gameDetails = [];
      this.modalOpen = false;
    },
    updateGame(game_id) {
      this.$router.push({path: '/game-update', query: { game_id: game_id }});
    }
  },
  computed: {
    gameList: function () {
      return this.games;
    }
  }
}
</script>

<style scoped>

</style>
